import { BookType, Stage } from '../types/exemplars';

type EngagementPromptsColor = {
  [key in BookType]: {
    main: string;
    hover: string;
  };
};

export type EngagementPromptsColors = Record<Stage, EngagementPromptsColor>;

export const ENGAGEMENT_PROMPTS_COLORS: EngagementPromptsColors = {
  early: {
    A: {
      main: '#e5d7ea',
      hover: '#D5C2E0',
    },
    B: {
      main: '#ece7f2',
      hover: '#D6C2DE',
    },
  },
  emergent: {
    A: {
      main: '#FBD6E2',
      hover: '#FFC3D7',
    },
    B: {
      main: '#FDEDF4',
      hover: '#FFDEEC',
    },
  },
  developing: {
    A: {
      main: '#ccebee',
      hover: '#c5e5e8',
    },
    B: {
      main: '#def4f6',
      hover: '#d0eaec',
    },
  },
  consolidating: {
    A: {
      main: '#ced6e9',
      hover: '#becae7',
    },
    B: {
      main: '#e3ebfc',
      hover: '#d6e3ff',
    },
  },
  extending: {
    A: {
      main: '#e0ecab',
      hover: '#ddec97',
    },
    B: {
      main: '#f1f2c1',
      hover: '#f1f3ad',
    },
  },
};
